import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

const CompanyEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);






    const [formData, setFormData] = useState({
        Name: '',
        CompanyCode: '',
        ContactNumber1: '',
        ContactNumber2: '',
        Email: '',
        GSTNumber: '',
        AddressLine1: '',
        AddressLine2: '',
        PinCode: '',
        City: '',
        District: '',
        State: '',
        Country: '',
        BillRemarks: '',
        ReprintPassword: '',
        PaymentQRUPIId: '',
        PaymentQRUPIName: '',
    });


    const [itemdata, setData] = useState([]);
    const companyid = 1;
    useEffect(() => {
        fetchData('PinCodeApi', `/${companyid}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });

    }, []);




    const fetchItemData = async () => {
        try {
            const response = await fetchData('CompanyApi', `/PackingDetails/${recordId}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Packing Details:', error);
        }
    };

    const handlePinCodeChange = (event) => {
        const value = event;
        if (value.length === 6) {
            const selectedPinCode = pinCodes.find(pinCode => pinCode.Postcode === value);
            if (selectedPinCode) {
                setFormData(prevData => ({
                    ...prevData,
                    City: selectedPinCode.City,
                    District: selectedPinCode.District,
                    State: selectedPinCode.State,
                    Country: selectedPinCode.Country
                }));
            }
        }
    };

    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });

        fetchItemData();
    }, [recordId]);





    const handleChange = event => {
        const { name, value } = event.target;
        console.log(name, value); // Add this line to debug
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('CompanyApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/companyIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;


    const [newRecordData, setNewRecordData] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const discountPercentage = parseFloat(formData.discountPercentage) || 0;
        // Update the new record data
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const addRecord = async () => {

        newRecordData.CompanyId = recordId;
        if (newRecordData.FromAmount === '' || newRecordData.ToAmount === '' || newRecordData.PackingCharge === '') {
            console.error('Invalid data. Please fill all required fields.');
            return;
        }

        try {
            await postData('PackingChargeApi', newRecordData, token);
            setNewRecordData({
                FromAmount: '',
                ToAmount: '',
                PackingCharge: '',
            });
            fetchItemData();
            setIsModalOpen(false);
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    const updateRecord = async (event) => {
        event.preventDefault();

        if (!updatedData) {
            console.error('No Item details selected.');
            return;
        }

        try {
            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CategoryId: id,
                Name: '',
                Rate: '',
                GSTRate: '',
                Description: '',
            });
            fetchItemData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const handleDelete = async () => {
        try {
            await deleteData('PackingChargeApi', `${deleteItemId}`, token);
            fetchItemData();
            setDeleteItemId(null);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">


            <div className="w-full mb-2 flex">
                <h5 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' ,color:'black'}}>COMPANY - EDIT</h5>
                <Button
                    variant="contained"
                    style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                    onClick={handleSubmit}
                >
                    UPDATE
                </Button>

                <Button
                    variant="contained"
                    color="error"
                    component={Link}
                    to="/companyIndex"
                    className="linkcolor"
                    style={{ marginLeft: '8px' }}
                >
                    CANCEL
                </Button>
            </div>

            <div className="w-full flex flex-wrap">
                <div className="w-full sm:w-3/5">

                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Company Name
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder="Enter Company name"
                                required
                                maxLength={50}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Company Code
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.CompanyCode} onChange={handleChange} type="text" placeholder="Enter Company Code" readOnly />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                                Contact Number 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder="Enter Contact Number 1"
                                required
                                maxLength={15}
                                pattern={phoneNumberPattern.source}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber2">
                                Contact Number 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber2' value={formData.ContactNumber2} onChange={handleChange} type="text" placeholder="Enter Contact Number 2"
                                maxLength={15}
                                pattern={phoneNumberPattern.source}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder="Enter Email"
                                maxLength={30}
                                pattern={emailPattern.source}
                            />
                        </div>


                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='GSTNumber' value={formData.GSTNumber} onChange={handleChange} type="text" maxLength={15} placeholder="Enter GST Number" />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Fssai Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BillRemarks' value={formData.BillRemarks} onChange={handleChange} type="text" placeholder="Enter fssai number"
                                maxLength={200}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                KOT Reprint Password
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ReprintPassword' value={formData.ReprintPassword} onChange={handleChange} type="password" placeholder="Enter password"
                                maxLength={10}
                            />
                        </div>
                        {isSuperAdmin && (
                            <>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                        Payment QR UPI Id
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentQRUPIId' value={formData.PaymentQRUPIId} onChange={handleChange} type="text" placeholder="Enter UPI Id" />
                                </div>

                                <div className="w-1/5 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                        Payment QR UPI Name
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentQRUPIName' value={formData.PaymentQRUPIName} onChange={handleChange} type="text" placeholder="Enter UPI Name" />
                                </div>
                            </>
                        )}



                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Address Line 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine1' value={formData.AddressLine1} onChange={handleChange} type="text" placeholder="Enter Address Line 1"
                                maxLength={200}
                                required
                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Address Line 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine2' value={formData.AddressLine2} onChange={handleChange} type="text" placeholder="Enter Address Line 2"
                                maxLength={200}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                PIN Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.PinCode}
                                name="PinCode"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Pin Code"
                                list="pinCodesList"
                                onBlur={(e) => handlePinCodeChange(e.target.value)} // Handle pin code change onBlur
                                required
                            />
                            <datalist id="pinCodesList">
                                {pinCodes.map((pinCode) => (
                                    <option key={pinCode.Id} value={pinCode.Postcode} />
                                ))}
                            </datalist>
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                City
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='City' value={formData.City} onChange={handleChange} type="text" placeholder="Enter City" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                District
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='District' value={formData.District} onChange={handleChange} type="text" placeholder="Enter District" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                State
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='State' value={formData.State} onChange={handleChange} type="text" placeholder="Enter State" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Country
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Country' value={formData.Country} onChange={handleChange} type="text" placeholder="Enter Country" readOnly />
                        </div>


                    </div>
                </div>
                <div className="w-full sm:w-2/5">
                    <div className="w-full mb-4 flex">
                        <div className="ml-auto flex items-center" style={{ marginTop: '20px' }}>
                            <h5 className="psheading linkcolor" style={{ fontFamily: 'Times New Roman',  color: 'black', marginRight: '8px' }}>PACKING CHARGE DETAILS</h5>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
                                Add Record
                            </button>
                        </div>


                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>


                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                From Amount
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="FromAmount"
                                                placeholder="Enter From Amount"
                                                value={newRecordData.FromAmount}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                To Amount
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="ToAmount"
                                                placeholder="Enter To Amount"
                                                value={newRecordData.ToAmount}
                                                onChange={handleInputChange}
                                            />
                                        </div>


                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                                Packing Charge
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="PackingCharge"
                                                placeholder="Enter Packing Charge"
                                                value={newRecordData.PackingCharge}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                            Add Record
                                        </button>
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>


                    <div className="w-full mb-4 flex">
                        <TableContainer component={Paper}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th style={{ padding: '8px', textAlign: 'center' }}>From Amount</th>
                                        <th style={{ padding: '8px', textAlign: 'center' }}>To Amount</th>
                                        <th style={{ padding: '8px', textAlign: 'center' }}>Packing Rate</th>
                                        <th style={{ padding: '8px' }}>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {itemdata.map((invdetail, index) => (
                                        <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>

                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.FromAmount}</td>
                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.ToAmount}</td>
                                            <td style={{ padding: '8px', fontSize: '14px', width: '15%', textAlign: 'center' }}>{invdetail.PackingCharge}</td>

                                            <td style={{ padding: '8px', marginTop: '-15px', width: '15%' }}>

                                                <IconButton onClick={() => openConfirmDialog(invdetail.Id)}>
                                                    <DeleteIcon style={{color:'red'}}/>
                                                </IconButton>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                                {/* Delete confirmation dialog */}
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </table>
                        </TableContainer>
                    </div>


                </div>
            </div>

        </div>

    );
};

export default CompanyEdit;
